export const optionsToStrategy = (options: {label: string, value: string | number}[]) => {
  return options.reduce((acc, {label, value}) => {
    return {
      ...acc, 
      [value]: label
    }
  }, {})
}